import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=23c8f857&scoped=true&"
import script from "./WorldMap.vue?vue&type=script&lang=js&"
export * from "./WorldMap.vue?vue&type=script&lang=js&"
import style0 from "./WorldMap.vue?vue&type=style&index=0&id=23c8f857&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c8f857",
  null
  
)

export default component.exports